export default {
  en: {
    translation: {
      image_search: {
        main_title: 'Image Search',

        inputPlaceholder: 'Search for images',
        customPlaceholder: 'Search {{site}}',
        show_options: 'Show Options',
        hide_options: 'Hide Options',
        filters_title: 'Site',
        all: 'all',

        rights: 'Usage rights:',

        rights_options: {
          not_filtered: 'not filtered by licence',
          free: 'free to use or share',
          free_com: 'free to use or share, even commercially',
          free_mod: 'free to use share or modify',
          free_mod_com: 'free to use, share or modify, even commercially',
        },

        search_error: 'Search failed, please try again.',
      },
    },
  },
};
